export default __webpack_public_path__ + "static/media/Ready.ff43a93b.svg";